const CLOUDFLARE_CODE_OVERRIDES = {
    NIR: "GB",
    SCT: "GB"
};
const regionNames = new Intl.DisplayNames([
    "en"
], {
    type: "region"
});
export const getSalesforceCountryCode = (cloudflareCountryCode)=>{
    if (!cloudflareCountryCode) return "";
    var _CLOUDFLARE_CODE_OVERRIDES_cloudflareCountryCode_toUpperCase;
    return (_CLOUDFLARE_CODE_OVERRIDES_cloudflareCountryCode_toUpperCase = CLOUDFLARE_CODE_OVERRIDES[cloudflareCountryCode.toUpperCase()]) !== null && _CLOUDFLARE_CODE_OVERRIDES_cloudflareCountryCode_toUpperCase !== void 0 ? _CLOUDFLARE_CODE_OVERRIDES_cloudflareCountryCode_toUpperCase : cloudflareCountryCode.toUpperCase();
};
export const getSalesforceCountryName = (cloudflareCountryCode)=>{
    const code = getSalesforceCountryCode(cloudflareCountryCode);
    if (!code) return "";
    try {
        var _regionNames_of;
        return (_regionNames_of = regionNames.of(code)) !== null && _regionNames_of !== void 0 ? _regionNames_of : "";
    } catch (e) {
        return "";
    }
};
